export default "__VITE_ASSET__TpD7x3Lh__"